function EnglishFlag({
  width = '60',
  height = '50',
  className,
}: {
  width?: string;
  height?: string;
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      viewBox="0 0 200 146"
    >
      <path
        d="M0 23.3278V45.2223H31.2667L0 23.3278ZM25.9111 145.222H72.2222V112.794L25.9111 145.222ZM127.778 112.8V145.222H174.083L127.778 112.8ZM0 100.778V122.672L31.2778 100.778H0ZM174.094 0.777832H127.778V33.2056L174.094 0.777832ZM200 122.678V100.778H168.717L200 122.678ZM200 45.2223V23.3278L168.728 45.2223H200ZM72.2222 0.777832H25.9111L72.2222 33.2056V0.777832Z"
        fill="#00247D"
      />
      <path
        d="M139.667 100.778L193.622 138.561C196.257 135.847 198.151 132.501 199.122 128.845L159.039 100.778H139.667ZM72.2222 100.778H60.3277L6.37775 138.556C9.27219 141.5 12.9833 143.606 17.1444 144.583L72.2222 106.017V100.778ZM127.778 45.2223H139.672L193.622 7.44453C190.678 4.45717 186.946 2.36689 182.861 1.41675L127.778 39.9834V45.2223ZM60.3277 45.2223L6.37775 7.44453C3.74415 10.161 1.84894 13.5059 0.872192 17.1612L40.9555 45.2223H60.3277Z"
        fill="#CF1B2B"
      />
      <path
        d="M200 89.6667H116.667V145.222H127.778V112.8L174.083 145.222H177.778C180.729 145.223 183.651 144.634 186.372 143.49C189.093 142.346 191.558 140.67 193.622 138.561L139.667 100.778H159.039L199.122 128.844C199.639 126.972 200 125.033 200 123V122.678L168.717 100.778H200V89.6667ZM0 89.6667V100.778H31.2778L0 122.672V123C0 129.061 2.43889 134.544 6.37778 138.556L60.3278 100.778H72.2222V106.017L17.1444 144.578C18.7778 144.967 20.4667 145.222 22.2222 145.222H25.9111L72.2222 112.794V145.222H83.3333V89.6667H0ZM200 23.0001C200.003 17.1777 197.712 11.5887 193.622 7.4445L139.672 45.2223H127.778V39.9834L182.861 1.41672C181.197 1.00854 179.491 0.794155 177.778 0.777834H174.094L127.778 33.2056V0.777834H116.667V56.3334H200V45.2223H168.728L200 23.3278V23.0001ZM72.2222 0.777834V33.2056L25.9111 0.777834H22.2222C19.2701 0.776548 16.3476 1.36568 13.6265 2.51058C10.9055 3.65548 8.44091 5.33302 6.37778 7.4445L60.3278 45.2223H40.9556L0.872222 17.1612C0.321001 19.0596 0.0276301 21.0235 0 23.0001L0 23.3278L31.2667 45.2223H0V56.3334H83.3333V0.777834H72.2222Z"
        fill="#EEEEEE"
      />
      <path
        d="M116.667 56.3334V0.777832H83.3333V56.3334H0V89.6667H83.3333V145.222H116.667V89.6667H200V56.3334H116.667Z"
        fill="#CF1B2B"
      />
    </svg>
  );
}

export { EnglishFlag };
